import * as React from "react";
import ArrepentimientoContainer from "../conteiners/arrepentimiento-container";

export default function ArrepentimientoPage() {
  return <ArrepentimientoContainer></ArrepentimientoContainer>;
}
